var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkerMultipleSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400 380C456 380 500 336 500 280C500 224 456 180 400 180C344 180 300 224 300 280C300 336 344 380 400 380ZM400 0C556 0 680 124 680 280C680 488 400 800 400 800C400 800 120 488 120 280C120 124 244 0 400 0Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerMultipleSvgrepoCom);
export default __webpack_public_path__ + "static/media/map-marker-multiple-svgrepo-com.d6f28018725a61cc5eced9777356380b.svg";
export { ForwardRef as ReactComponent };